import styled from "styled-components"
import { Item, List } from "components/Ui/List/List"

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 30rem;
  height: 30rem;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 1rem;
  margin: 0 auto 2rem;
`

export const Image = styled.img`
  width: 100% !important;
  display: block;
  flex-shrink: 0;
  max-height: 100%;
  object-fit: contain;
`

export const Parent = styled.strong`
  margin-left: 0.5rem;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.5rem;
  position: relative;
  border-top: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};

  p {
    line-height: 2.4rem;
  }
`

export const StyledList = styled(List)`
  margin-bottom: 0;
`

export const StyledItem = styled(Item)`
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};
`

export const IncomingStockButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  padding: 1.2rem 1.5rem;
  margin-top: 1rem;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${(p) => p.theme.colors.black};
  transition: all 0.2s;

  &:hover {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.turquoiseDark};

    svg {
      fill: ${(p) => p.theme.colors.turquoiseDark};
    }
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;
    transition: fill 0.2s;
  }
`
